module.exports = __webpack_public_path__ + "img/chair.5aeb119b.png";